import React from 'react';
import { IEntityDetailsProps } from './detailsTypes';
import { ActionsPanel } from './Panels/Actions';
import { PropertiesPanel } from './Panels/Properties';
import { CustomPreviewPanel } from './Panels/CustomPreviewPanel';
import { TagsPanel } from './Panels/Tags';
import { getPanelClasses } from './Panels/panelSettings';

export function SecondaryDetails(props: IEntityDetailsProps) {
    const showCustomPreview: boolean = !!(props?.customPreview?.length);
    const showProperties: boolean = !!(props?.entityProperties?.length && !showCustomPreview);

    const showTagsEditor: boolean = !!(
      props.entityId &&
      props.typeName &&
      props.shortTypeName
    );

  return (
    <div className={getPanelClasses('right', 12, 4)}>
    {props.getActionHolder && <ActionsPanel getActionHolder={props.getActionHolder} />}
    {showProperties && <PropertiesPanel properties={props.entityProperties} />}
    {showCustomPreview && <CustomPreviewPanel preview={props.customPreview} />}
    {showTagsEditor && (
      <TagsPanel
        objectId={props.entityId}
        objectShortType={props.shortTypeName}
        objectType={props.typeName}
      />
    )}
  </div>
  );
}
